export default __webpack_public_path__ + "static/media/img-avatar.bae90d42.png";